ready(function () {

  const accordions = document.querySelectorAll('.blockAccordion details');
  accordions.forEach((accordion) => {
    accordion.addEventListener('toggle', () => {
      if (accordion.open) {
        accordions.forEach((otherAccordion) => {
          if (otherAccordion !== accordion) {
            otherAccordion.open = false;
          }
        });
      }
    });
  });

});